import z from "zod";
import {
  AVAILABILITY_DATE_NOT_IN_PAST_MESSAGE,
  isAvailabilityDateYmdNotInPast,
} from "./availability-date-validation";

export const exclusionSchema = z
  .object({
    teacherId: z.number().min(1, { message: "Teacher ID is required" }),
    date: z.string().min(1, { message: "Date is required" }),
    startTime: z.string().nullable().optional(),
    endTime: z.string().nullable().optional(),
    reason: z.string().nullable().optional(),
  })
  .refine((data) => isAvailabilityDateYmdNotInPast(data.date), {
    message: AVAILABILITY_DATE_NOT_IN_PAST_MESSAGE,
    path: ["date"],
  })
  .refine(
    (data) => {
      if (data.startTime && data.endTime) {
        return data.endTime > data.startTime;
      }
      return true;
    },
    {
      message: "End time must be after start time",
      path: ["endTime"],
    },
  );

export type ExclusionSchemaType = z.infer<typeof exclusionSchema>;
